/**
 * @namespace Stores
 * @category Stores
 * @module analysis-store
 * */

export default {
  namespaced: true,

  state: {
    selectedTab: '',
    checkedCategoriesIdList: [],
    showMultipleDate: false,
    showRangeDate: true,
    selectedDate: null,
    isValidForm: false,
  },
  getters: {
    getSelectedTab(state) {
      return state.selectedTab
    },
    getCheckedCategoriesIdList(state) {
      return state.checkedCategoriesIdList
    },
    getShowMultipleDate(state) {
      return state.showMultipleDate
    },
    getShowRangeDate(state) {
      return state.showRangeDate
    },
    getSelectedDate(state) {
      return state.selectedDate
    },
    getIsValidForm(state) {
      return state.isValidForm
    },
  },
  mutations: {
    setSelectedTab(state, infos = null) {
      state.selectedTab = infos || null
    },
    setCheckedCategoriesIdList(state, infos = null) {
      state.checkedCategoriesIdList = infos || null
    },
    setShowMultipleDate(state, val) {
      return (state.showMultipleDate = val)
    },
    setShowRangeDate(state, val) {
      return (state.showRangeDate = val)
    },
    setSelectedDate(state, infos = null) {
      state.selectedDate = infos || null
    },
    setIsValidForm(state, infos = null) {
      return (state.isValidForm = infos || null)
    },
  },
  actions: {
    async switchPeriode({ commit, getters }) {
      commit('setShowMultipleDate', !getters.getShowMultipleDate)
      commit('setShowRangeDate', !getters.getShowRangeDate)
    },
    switchValidForm({ commit, getters }) {
      commit('setIsValidForm', !getters.isValidForm)
    },
    switchNotValidForm({ commit }) {
      commit('setIsValidForm', false)
    },
  },
}
